module.exports = __webpack_public_path__ + "static/media/plant.d055e993.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/plant.svg
// module id = 175
// module chunks = 0